import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddWishlistDialogComponent } from '../add-wishlist-dialog/add-wishlist-dialog.component';
import { UserWishlistDialogComponent } from '../user-wishlist-dialog/user-wishlist-dialog.component';
import { WishlistService } from '../../../services/raintree/Transmission/wishlist.service';
import {
  ReachWishListResponse,
  WishlistResponse,
} from '../../../services/raintree/interfaces/wishlist.interface';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { NamesToUpdateService } from '../../../services/raintree/Transmission/names-to-update.service';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { ReachUserWishlistDialogComponent } from '../../../reach-defaulter/reach-user-wishlist-dialog/reach-user-wishlist-dialog.component';
import { EditWishlistDialogComponent } from '../edit-wishlist-dialog/edit-wishlist-dialog.component';
import { DeleteWishlistDialogComponent } from '../delete-wishlist-dialog/delete-wishlist-dialog.component';
import { AddToFavouritesComponent } from '../../../reach-defaulter/add-to-favourites/add-to-favourites.component';
import { ActivatedRoute } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { ReviewDataService } from '../../../services/raintree/Transmission/review-data.service';
import { Subject } from 'rxjs';
import { AppConfigService } from '../../../services/config/app-config.service';
import { PrintAndMonitorService } from '../../../services/raintree/Transmission/print-and-monitor.service';
import { SearchService } from '../../../services/common/search.service';
import { Permissions } from '../../../enum/permission';

@Component({
  selector: 'wishlist-dialog',
  standalone: true,
  templateUrl: './wishlist-dialog.component.html',
  styleUrl: './wishlist-dialog.component.scss',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    LoaderComponent,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatAutocomplete,
  ],
})
export class WishlistDialogComponent implements OnInit, OnDestroy {
  selectedState: string = '';
  selectedDistrict: string = '';
  stateName: string = '';
  districtName: string = '';
  selectedPin: string = '';
  pincodes: any = [];
  pin = new FormControl('');
  pincodeList: any[] = [];
  // private _reviewService: any;
  pincode: any = [];

  private searchSubject = new Subject<string>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private _namesToUpdateService: NamesToUpdateService,
    private dialogRef: MatDialogRef<WishlistDialogComponent>,
    public reviewService: ReviewDataService,
    private _appConfig: AppConfigService,
    private _printAndMonitorService: PrintAndMonitorService,
    private _searchService: SearchService,
  ) {
    // if(this.data.pincode){
    // this.pin.disable()
    // }
  }
  @ViewChild('autopin') autopin!: MatAutocomplete;
  @ViewChild('autoId') autoId!: MatAutocomplete;
  isLoading: boolean = false;
  isPinFetched: boolean = false;
  // isValidPin: boolean = false;
  wishlists: any = [];
  added: boolean = false;
  searchTerm: string = '';
  slNo: string = '';
  searchName = new FormControl('')
  memKey = new FormControl('')
  tempReachData: any[] = [];
  isEditable: boolean = false;
  isDelete: boolean = false;
  isReload = false;
  queryParams: any;
  permissionArr: any = {};
  userList: any[] = [];
  finalPerm: any[] = [];
  filterUserList: any[] = [];
  canRename: boolean = false;
  canDeleteWishlist: boolean = false;
  canDeleteWishlistItem: boolean = false;
  userId = new FormControl('');
  fieldWorkerName = new FormControl('');
  selectedId: number = 0;
  selectedUser: string = '';
  workerList: any = [];
  queryParamsObj: any = {};
  user: any;

  ngOnInit(): void {
    this.user = localStorage.getItem('userId');

    this.added = false;
    this.queryParams = { ...this._activatedRoute.snapshot.queryParams };
    this.selectedDistrict =
      this.data.selectedDistrict || this.queryParams['district'];
    this.selectedState = this.data.selectedState || this.queryParams['state'];
    this.permissionArr = this._appConfig.fetchPermissionv3ByViewName();
    this.fetchPermissions();

    console.log(this.data.pincode);
    

    if (this.queryParams['pincode']) {
      this.data.pincode = this.queryParams['pincode'];
      this.pin.setValue(this.queryParams['pincode']);
      this.fetchWishlistBtTYpe();
    }else{
      this.fetchWishlistBtTYpe();
    }
    this.pin.valueChanges.subscribe((item: any) => {
      if (!item.length) {
        this.pincodeList = this.pincodes
      }
      if (item && item.length > 0) {
        this.pincodeList = this.pincodes.filter((pincode: string) =>
          pincode.includes(item)
        );
      } else if (
        item?.length == 0 &&
        this.fieldWorkerName.value?.length == 0 &&
        this.searchName.value?.length == 0
      ) {
        this.toaster.success('Select any filter to view wishlist');
        delete this.queryParamsObj.pincode;
         this.fetchWishlistBtTYpe();
      } else if (
        item?.length == 0 &&
        (this.fieldWorkerName.value || this.searchName)
      ) {
        delete this.queryParamsObj.pincode;

        this.fetchPrintAndMonitorWishlist();
      }
    });

    if (this.data.pincode) {
      this.queryParamsObj.pincode = this.data.pincode;
    }

    this.fieldWorkerName.valueChanges.subscribe((item: any) => {
      if (item && item.length > 0) {
        this.filterUserList = this.workerList.filter((value: any) =>
          value.name.toLowerCase().includes(item.toLowerCase())
        );
      } else if (
        item.length == 0 &&
        this.pin.value?.length == 0 &&
        this.searchName.value?.length == 0
      ) {
        this.toaster.success('Select any filter to view wishlist');
        this.filterUserList = this.workerList.filter(
          (value: any) => value.name
        );
         this.fetchWishlistBtTYpe();
        delete this.queryParamsObj.userId;
      } else if (item.length == 0 && (this.pin.value || this.searchName.value?.length != 0)) {
        this.filterUserList = this.workerList.filter(
          (value: any) => value.name
        );
        delete this.queryParamsObj.userId;
        this.fetchPrintAndMonitorWishlist();
      }
    });

    if (
      this.data.type === 'centralizedReach' ||
      this.data.type === 'Reach' ||
      this.data.type === 'centralizedFd' ||
      this.data.type === 'fd'
    ) {
      this.fetchWishlistBtTYpe();
    }

    this.searchName.valueChanges.subscribe((value: any) => {
      if (
        value.length == 0 &&
        this.fieldWorkerName.value?.length == 0 &&
        this.pin?.value?.length == 0
      ) {
        this.toaster.success('Select any filter to view wishlist');
        // this.isValidPin = false;
        this.fetchWishlistBtTYpe();
      } else if (
        value.length === 0 &&
        (this.fieldWorkerName.value || this.pin.value)
      ) {
        this.fetchPrintAndMonitorWishlist();
      }
    });
    if (this.data.type === 'centralizedPm' || this.data.type === 'pm') {
      // this.fetchUsers();
      this.fetchDistrictPincode();
    }
  }

  fetchPermissions() {
    // this.permissionArr = this._appConfig.fetchPermissionsByViewName();
    this.finalPerm = [];
    const countryPerm = this.permissionArr['INDIA'];
    if (this.selectedState != '' && this.selectedState) {
      this.finalPerm = countryPerm?.allStatesPerm;
      const statePerm = countryPerm?.statePerms[this.selectedState];
      if (this.selectedDistrict != '' && this.selectedDistrict && statePerm?.districtPerms[this.selectedDistrict]) {
        this.finalPerm = [...this.finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[this.selectedDistrict]];

      }
    }
    this.canRename = this.finalPerm?.includes(Permissions.CanRenameWishlist)
    this.canDeleteWishlist = this.finalPerm?.includes(Permissions.CanDeleteWishlist)
    this.canDeleteWishlistItem = this.finalPerm?.includes(Permissions.CanDeleteWishlistItem)

  }

  fetchWishlistBtTYpe(check?: number) {
    if (this.data.type === 'centralizedReach' || this.data.type === 'Reach') {
      this.fetchReachWishlist();
    } else if (this.data.type === 'centralizedFd' || this.data.type === 'fd') {
      this.fetchWishlist();
    } else if (this.data.type === 'centralizedPm' || this.data.type === 'pm') {
      this.fetchPrintAndMonitorWishlist();
    }
  }
  fetchReachWishlist() {
    this.isLoading = true;
    this._wishlistService.fetchReachWishlists().subscribe({
      next: (response: ReachWishListResponse) => {
        this.wishlists = response.data;
        this.tempReachData = this.wishlists;
        this.isLoading = false;
      },
      error: (error) => {
        this.toaster.error(error);
        this.isLoading = false;
      },
    });
  }

  fetchUsers() {
    let queryParams = { ...this._activatedRoute.snapshot.queryParams };
    let queryParamsObj = {};
    queryParamsObj = {
      uiState: queryParams['state'] || this.selectedState,
      uiDistrict: queryParams['district'] || this.selectedDistrict,
      pincode: queryParams['pincode'] || ''
    };
    const cleanedObj = Object.fromEntries(
      Object.entries(this.queryParamsObj).filter(
        ([key, value]) => value !== null && value !== '' && value !== undefined
      )
    );
    if (!this.workerList.length) {
      this.isLoading = true;
      this._printAndMonitorService.fetchDatumUsers(queryParamsObj).subscribe({
        next: (response) => {
          this.workerList =
            response.data.length > 0
              ? response.data.map((item: any) => {
                return {
                  userId: item.userId,
                  name: item.name,
                  email: item.email,
                };
              })
              : [];
          this.filterUserList = this.workerList;
          this.isLoading = false;
        },
        error: (error) => {
          this.toaster.error(error);
        },
      });
    }
  }
  fetchDistrictPincode() {
    let queryParams = { ...this._activatedRoute.snapshot.queryParams };
    if (!this.pincodes.length) {
      this.isLoading = true;
      this.reviewService
        .fetchPinCode(queryParams['state'], queryParams['district'])
        .subscribe({
          next: (response) => {
            this.pincodes =
              response.data.length > 0
                ? response.data.map((item: { pincode: any }) => item.pincode)
                : [];
            this.pincodeList = this.pincodes;
            // if (!this.data.pincode && !queryParams['pincode']) {
            //   this.pin.setValue(this.pincodeList[0]);
            //   // this.onSelectPin(this.pincodeList[0]);
            // }
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.toaster.error(error);
          },
        });
    }
  }

  onSelectPin(item: any) {
    this.queryParamsObj.pincode = item;
    this.fetchPrintAndMonitorWishlist();
  }

  onSelectionUser(item: any) {
    this.queryParamsObj.userId = item.userId;
    this.fetchPrintAndMonitorWishlist();
  }
  fetchPrintAndMonitorWishlist(id?: number) {
    this.isLoading = true;
    this.queryParamsObj = {
      uiState: this.selectedState,
      uiDistrict: this.selectedDistrict,
      pincode: this.queryParamsObj.pincode || this.data.pincode || '',
      userId: this.queryParamsObj.userId || '',
      searchString: this.searchName.value?.length! > 0 ? this.searchName.value : '',
      memKey: this.memKey?.value
    };

    const cleanedObj = Object.fromEntries(
      Object.entries(this.queryParamsObj).filter(
        ([key, value]) => value !== null && value !== '' && value !== undefined
      )
    );
    this._wishlistService.fetchWishlistsName(cleanedObj).subscribe({
      next: (response: WishlistResponse) => {
        console.log("wislist names details=", response.data);

        if (response.data.length > 0) {
          this.wishlists = response.data;
          this.wishlists = response.data.map((item: any) => {
            return {
              id: item.id,
              name: item.title,
              pincode: item.pincode,
              item_count: item.item_count,
              userID: item.wishlistCreatedBy,
            };
          });
          this.tempReachData = this.wishlists;
          this.isLoading = false;
        } else if (response.data.length == 0) {
          this.toaster.success(response.message);
          this.wishlists = [];
          this.isLoading = false;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
        this.dialogRef.close();
      },
    });
  }

  onSearch(event: any) {
    const searchTerm = event.trim().toLowerCase();
    // this.wishlists = searchTerm
    //   ? this.tempReachData.filter((item: { name: string }) => {
    //     return item?.name.toLowerCase().includes(searchTerm);
    //   })
    //   : this.tempReachData;

    if (searchTerm?.length >= 1) {
      this.wishlists = this._searchService.fuseFilterData(
        this.tempReachData,
        searchTerm,
        ['name'],
        1   // min length to search
      )
    }
    else {
      this.wishlists = this.tempReachData;
    }
  }


  onWishlistName() {
    if (this.searchName.value?.length! >= 4) {
      this.fetchPrintAndMonitorWishlist();
    } else
      this.toaster.error('Type min 4 characters to search')
  }
  OnMemKeySearch() {
    if (this.memKey.value?.length! >= 8) {
      this.fetchPrintAndMonitorWishlist();
    } else
      this.toaster.error('Serial number must be 8-9 digits.')
  }
  fetchWishlist() {
    let paramsObj = {
      listType: 'PHL',
      uiState: this.selectedState,
      uiDistrict: this.selectedDistrict,
    };
    this.isLoading = true;
    this._wishlistService.fetchWishlists(paramsObj).subscribe({
      next: (response: WishlistResponse) => {
        this.wishlists = response.data;
        this.wishlists = response.data.map((item: any) => {
          return {
            id: item.id,
            name: item.title,
            status: item.status,
            item_count: item.item_count,
            transferredToId: item.transferredToId ? item.transferredToId : '',
            transferredToName: item.transferredToName
              ? item.transferredToName
              : '',
          };
        });
        this.tempReachData = this.wishlists;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.dialogRef.close();
      },
    });
  }

  onEditClick(item: any, event: MouseEvent) {
    event.stopPropagation();
    let name = item.name !== undefined ? item.name : item.title;
    const dialogRef = this.dialog.open(EditWishlistDialogComponent, {
      data: {
        id: item.id,
        name: name,
        type: this.data.type,
        state: this.selectedState,
        district: this.selectedDistrict,
      },
    });
    if (this.data.type === 'centralizedReach' || this.data.type === 'Reach') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchReachWishlist();
        }
      });
    } else if (this.data.type === 'centralizedFd' || this.data.type === 'fd') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchWishlist();
        }
      });
    } else if (this.data.type === 'centralizedPm' || this.data.type === 'pm') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchPrintAndMonitorWishlist();
        }
      });
    }
  }

  onDeleteClick(item: any, event: MouseEvent) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(DeleteWishlistDialogComponent, {
      data: {
        id: item.id,
        name: item.name,
        type: this.data.type,
        pincode: this.queryParams['pincode'] || item.pincode,
        state: this.data.state,
        district: this.data.district,
      },
    });
    if (this.data.type === 'centralizedReach' || this.data.type === 'Reach') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchReachWishlist();
        }
      });
    } else if (this.data.type === 'centralizedFd' || this.data.type === 'fd') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchWishlist();
          // this.isReload = true;
        }
      });
    } else if (this.data.type === 'centralizedPm' || this.data.type === 'pm') {
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.fetchPrintAndMonitorWishlist();
        }
      });
    }
  }

  openAddWishlistDialog() {
    console.log(this.data);
    const dialogRef = this.dialog.open(AddWishlistDialogComponent, {
      data: {
        record: this.data,
        type: this.data.type,
        pin: this.pincodeList,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pin.setValue(result.pincode);
        this.queryParamsObj.pincode = result.pincode
        // if (!this.queryParams['pincode']) {
        this.fetchWishlistBtTYpe();
        // }
        // this.isReload = true;
      }
    });
  }

  openUserWishListDialog(wishlist: any, type: string) {
    this.isLoading = true
    if (this.data.memberId && type === 'fd' && this.data?.status != 'P') {
      let bodyObj = {
        memberId: this.data.memberId,
        listType: 'PHL',
        uiState: this.selectedState,
        uiDistrict: this.selectedDistrict,
      };
      const dialogRef = this._namesToUpdateService
        .addItemToWishlist(wishlist.id, bodyObj)
        .subscribe({
          next: (response: any) => {
            const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Datum added to wishlist '${wishlist?.title || wishlist?.name
                  }' successfully!`,
                subHeading:
                  'Your can access all wish-lists from the ‘My wishlists’',
                buttonValue: 'Done',
              },
            });
            this.added = true;
            dialogRef.afterClosed().subscribe((value) => {
              if (value) {
                this.dialogRef.close(this.data.memberId);
              }
            });
            // this.isReload = true;
            this.isLoading = false;
            this.fetchWishlist();
          },
          error: (error) => {
            this.isLoading = false;
            this.toaster.error(error);
          },
        });
    } else if (!!this.data.memberId && type === 'pm') {
      let bodyObj = {
        memKeys: [String(this.data.memberId)],
        uiState: this.queryParams['state'],
        uiDistrict: this.queryParams['district'],
        pincode: this.queryParams['pincode'],
        wishlistId: String(wishlist.id),
      };
      this._namesToUpdateService.addWishlist(bodyObj).subscribe({
        next: (response: any) => {
          const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: `Datum added to wishlist '${wishlist.name}' successfully!`,
              subHeading:
                'Your can access all wish-lists from the ‘My wishlists’',
              buttonValue: 'Done',
            },
          });
          this.added = true;
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    } else if (
      type === 'centralizedFd' ||
      type === 'centralizedReach' ||
      type === 'fd' ||
      type === 'Reach' ||
      type === 'centralizedPm'
    ) {
      if (type == 'centralizedReach' && this.data.type == 'centralizedReach') {
        wishlist.type = this.data.type;
        const dialogRef = this.dialog.open(ReachUserWishlistDialogComponent, {
          width: '97vw',
          maxWidth: '100vw',
          height: 'calc(100vh - 80px)',
          data: { wishlist },
        });
        this.isLoading = false;
        dialogRef.afterClosed().subscribe(() => this.fetchReachWishlist());
      } else if (type == 'Reach' && this.data.type == 'Reach') {
        let reqData = {
          wid: wishlist.id,
          memCode: this.data.row.memberCode,
          fcode: this.data.row.familyCode,
          memKey: this.data.row.slno,
          remark: '',
        };
        this._wishlistService.addDataReachWishlist(reqData).subscribe({
          next: (response: any) => {
            const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Datum has been added to '${wishlist.name}' Wishlist sucessfully.`,
                subHeading:
                  'Your can access all wish-lists from the My Signup menu on the Reach Defaulter page ',
                buttonValue: 'Finish',
              },
            });
            this.isLoading = false;
            this.added = true;
          },
          error: (error) => {
            this.isLoading = false;
            this.toaster.error(error);
          },
        });
      } else if (type == 'centralizedPm' && this.data.type == 'centralizedPm') {
        wishlist.title = wishlist.name;
        const dialogRef = this.dialog.open(UserWishlistDialogComponent, {
          width: '80vw',
          maxWidth: '100vw',
          height: 'calc(100vh - 80px)',
          panelClass: 'common-pannel-dialog-container',
          data: {
            perm: this.finalPerm.includes(
              Permissions.CanDeleteWishlistItem
            ),
            logUserid: Number(this.user),
            wishlist,
            type,
            selectedState: this.queryParams['state'],
            selectedDistrict: this.queryParams['district'],
          },
        });
        this.isLoading = false;
        dialogRef.afterClosed().subscribe((value) => {
          if (value) {
            this.fetchPrintAndMonitorWishlist();
            // this.isReload = true;
          }
          // else if (!value) {
          // this.fetchPrintAndMonitorWishlist();
          // }
        });
      } else if (
        type === 'centralizedFd' &&
        this.data.type === 'centralizedFd'
      ) {
        const dialogRef = this.dialog.open(UserWishlistDialogComponent, {
          width: '80vw',
          maxWidth: '100vw',
          height: 'calc(100vh - 80px)',
          panelClass: 'common-pannel-dialog-container',
          data: {
            wishlist,
            type,
            selectedState: this.selectedState,
            selectedDistrict: this.selectedDistrict,
          },
        });
        this.isLoading = false;
        dialogRef.afterClosed().subscribe((value) => {
          if (value) {
            this.fetchWishlist();
            // this.isReload = true;
          }
        });
      }
    }
  }

  openFavDialog(type: string) {
    if (type === 'centralizedReach') {
      const dialogRef = this.dialog.open(AddToFavouritesComponent, {
        width: '97vw',
        maxWidth: '100vw',
        height: 'calc(100vh - 80px)',
      });
      dialogRef.afterClosed().subscribe((value) => {
        this.isLoading = false;
        if (value) {
          this.fetchReachWishlist();
        }
      });
    } else if (type === 'centralizedFd') {
      const dialogRef = this.dialog.open(UserWishlistDialogComponent, {
        width: '97vw',
        maxWidth: '100vw',
        height: 'calc(100vh - 80px)',
        panelClass: 'common-pannel-dialog-container',
        data: {
          type,
          favorites: 'like',
          selectedState: this.queryParams['state'] || this.selectedState,
          selectedDistrict:
            this.queryParams['district'] || this.selectedDistrict,
        },
      });
      dialogRef.afterClosed().subscribe((value) => {
        this.isLoading = false;
        if (value) {
          this.fetchWishlist();
          // this.isReload = true;
        }
      });
    } else if (type === 'centralizedPm') {
      const dialogRef = this.dialog.open(UserWishlistDialogComponent, {
        width: '97vw',
        maxWidth: '100vw',
        height: 'calc(100vh - 80px)',
        panelClass: 'common-pannel-dialog-container',
        data: {
          type,
          favorites: 'like',
          selectedState: this.selectedState,
          selectedDistrict: this.selectedDistrict,
        },
      });
      dialogRef.afterClosed().subscribe((value) => {
        this.isLoading = false;
        if (value) {
          this.fetchPrintAndMonitorWishlist();
          // this.isReload = true;
        }
      });
    } else this.toaster.error("Click on 'View wishlist' to view Favourites!");
  }

  onClose() {
    this.pincodeList = [];
    this.pincodes = [];
    this.userList = [];
    this.filterUserList = [];
    this.workerList = [];
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.pincodeList = [];
    this.pincodes = [];
    this.userList = [];
    this.filterUserList = [];
    this.workerList = [];
  }
}
